import { render, staticRenderFns } from "./singleAppVersionList.vue?vue&type=template&id=62cdd562&scoped=true"
import script from "./singleAppVersionList.vue?vue&type=script&lang=js"
export * from "./singleAppVersionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cdd562",
  null
  
)

export default component.exports